import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  TextField,
  Typography,
  MenuItem,
  Select,
  Paper,
  Box,
  InputLabel,
} from "@mui/material";
import PrintRoundedIcon from "@mui/icons-material/PrintRounded";
import ReactToPrint from "react-to-print";
import { useGuia } from "../../../Hooks/guia";
import { Tabela } from "../Tabela";
import { SelectAdquirentes } from "./SelectAdquirentes";

export const SeletorPeriodo = () => {
  const [mesInicial, setMesInicial] = useState(new Date().getMonth() + 1);
  const [anoInicial, setAnoInicial] = useState(new Date().getFullYear());
  const [mesFinal, setMesFinal] = useState(new Date().getMonth() + 1);
  const [anoFinal, setAnoFinal] = useState(new Date().getFullYear());
  const [print, setPrint] = useState(false);

  const conponentRef = React.useRef(null);

  const {
    setPeriodoFinal,
    setPeriodoInicial,
    periodoInicial,
    periodoFinal,
    somenteResumo,
    setSomenteResumo,
    tipo,
    setTipo,
  } = useGuia();

  useEffect(() => {
    setPeriodoInicial(`${anoInicial}-${mesInicial.toString().padStart(2, "0")}`);
    setPeriodoFinal(`${anoFinal}-${mesFinal.toString().padStart(2, "0")}`);
  }, [anoInicial, anoFinal, mesFinal, mesInicial, setPeriodoInicial, setPeriodoFinal]);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "flex-end",
          gap: 1.5,
          width: "100%",
        }}
      >
        {/* ADQUIRENTE */}
        <Box
          sx={{
            flex: { xs: "1 1 100%", lg: "1 1 320px" },
            minWidth: { xs: "100%", lg: 280 },
          }}
        >
          <SelectAdquirentes />
        </Box>

        {/* TIPO */}
        <Box
          sx={{
            flex: { xs: "1 1 calc(50% - 6px)", lg: "0 0 150px" },
            minWidth: 140,
          }}
        >
          <FormControl fullWidth size="small">
            <InputLabel>Tipo</InputLabel>
            <Select
              label="Tipo"
              value={tipo}
              onChange={(ev) => setTipo(ev.target.value as any)}
            >
              <MenuItem value="todos">Todos</MenuItem>
              <MenuItem value="urbano">Urbano</MenuItem>
              <MenuItem value="rural">Rural</MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* RESUMO */}
        <Box
          sx={{
            flex: { xs: "1 1 calc(50% - 6px)", lg: "0 0 120px" },
            minWidth: 110,
            display: "flex",
            alignItems: "center",
            height: 40,
          }}
        >
          <FormControlLabel
            sx={{ m: 0 }}
            control={
              <Checkbox
                checked={somenteResumo}
                onChange={() => setSomenteResumo((prev) => !prev)}
                size="small"
              />
            }
            label="Resumo"
          />
        </Box>

        {/* INICIAL */}
        <Box
          sx={{
            flex: { xs: "1 1 100%", lg: "0 0 230px" },
            minWidth: 220,
          }}
        >
          <Typography sx={{ fontSize: 12, fontWeight: 700, mb: 0.5 }}>
            Inicial
          </Typography>

          <Box sx={{ display: "flex", gap: 1 }}>
            <TextField
              size="small"
              fullWidth
              type="number"
              value={mesInicial}
              inputProps={{ min: 1, max: 12 }}
              onChange={(ev) => {
                const valor = Number(ev.target.value);
                if (valor <= 0) {
                  setMesInicial(12);
                  setAnoInicial((prev) => prev - 1);
                } else if (valor >= 13) {
                  setMesInicial(1);
                  setAnoInicial((prev) => prev + 1);
                } else {
                  setMesInicial(valor);
                }
              }}
            />

            <TextField
              size="small"
              fullWidth
              type="number"
              value={anoInicial}
              onChange={(ev) => setAnoInicial(Number(ev.target.value))}
            />
          </Box>
        </Box>

        {/* FINAL */}
        <Box
          sx={{
            flex: { xs: "1 1 100%", lg: "0 0 230px" },
            minWidth: 220,
          }}
        >
          <Typography sx={{ fontSize: 12, fontWeight: 700, mb: 0.5 }}>
            Final
          </Typography>

          <Box sx={{ display: "flex", gap: 1 }}>
            <TextField
              size="small"
              fullWidth
              type="number"
              value={mesFinal}
              inputProps={{ min: 1, max: 12 }}
              onChange={(ev) => {
                const valor = Number(ev.target.value);
                if (valor <= 0) {
                  setMesFinal(12);
                  setAnoFinal((prev) => prev - 1);
                } else if (valor >= 13) {
                  setMesFinal(1);
                  setAnoFinal((prev) => prev + 1);
                } else {
                  setMesFinal(valor);
                }
              }}
            />

            <TextField
              size="small"
              fullWidth
              type="number"
              value={anoFinal}
              onChange={(ev) => setAnoFinal(Number(ev.target.value))}
            />
          </Box>
        </Box>

        {/* BOTÃO */}
        <Box
          sx={{
            flex: { xs: "1 1 100%", lg: "0 0 auto" },
            display: "flex",
            alignItems: "flex-end",
          }}
        >
          <ReactToPrint
            content={() => conponentRef.current}
            trigger={() => (
              <Button
                variant="contained"
                startIcon={<PrintRoundedIcon />}
                sx={{
                  height: 40,
                  px: 2.5,
                  borderRadius: 1.5,
                  fontWeight: 700,
                  textTransform: "none",
                  whiteSpace: "nowrap",
                }}
              >
                Imprimir
              </Button>
            )}
            onBeforeGetContent={() => setPrint(true)}
            onAfterPrint={() => setPrint(false)}
          />
        </Box>
      </Box>

      <div hidden={!print}>
        <div ref={conponentRef}>
          <Typography
            sx={{
              fontSize: 14,
              textAlign: "center",
              mt: 2,
            }}
          >
            ITBI INFORMADO DE {periodoInicial.replace("-", "/")} até{" "}
            {periodoFinal.replace("-", "/")}
          </Typography>

          <Tabela imprimir tipo={tipo} />
        </div>
      </div>
    </>
  );
};